import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./utils/languageContext";
import { AuthProvider } from "./utils/authContext";
import { AlertProvider } from "./utils/AlertContext";
import { useAuth } from "./utils/authContext";
import { useAlert } from "./hooks/useAlert";
import Alert from "./components/alert/alert";
import HomePage from "./pages/homepage/homePage";
import Login from "./pages/login/login";
import Register from "./pages/login/register";
import OnboardForm from "./pages/login/onboard/onboardForm";
import AboutUs from "./pages/aboutUs/aboutUs";
import Footer from "./components/footer/footer";
import UserRoutes from "./routes/userRoutes";
import AdminRoutes from "./routes/adminRoutes";
import Navbar from "./components/navbar/navbar";
import AdminNavbar from './admin/components/adminNavbar';
import ConfirmEmail from "./pages/login/confirmEmail";
import NotFound from "./pages/notFound/notFound";
import ResetPassword from "./pages/login/resetPassword";
import EmailConfirmSuccess from "./pages/login/emailConfirmSuccess";
import './styles/pages.css';

// ✅ Eigene Komponente – re-rendert nur sich selbst wenn Alert sich ändert
const AlertDisplay = () => {
    const { alert, closeAlert } = useAlert();
    return alert ? <Alert type={alert.type} onClose={closeAlert}>{alert.message}</Alert> : null;
};

const AppContent = () => {
    const { user, isAuthenticated } = useAuth() || {};
    const isAdmin = user?.role === "admin";

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <AlertDisplay />
            {isAdmin ? <AdminNavbar /> : <Navbar />}
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/register/confirm-email" element={<ConfirmEmail />} />
                <Route path="/register/confirm-success/:token" element={<EmailConfirmSuccess />} />
                <Route path="/register/onboard" element={<OnboardForm />} />
                <Route path='/resetPassword/:token' element={<ResetPassword />} />
                {!isAdmin && isAuthenticated && <Route path="/dashboard/*" element={<UserRoutes />} />}
                {isAdmin && <Route path="/admin/*" element={<AdminRoutes />} />}
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
        </div>
    );
};

const App = () => {
    return (
        <LanguageProvider>
            <AuthProvider>
                <AlertProvider>
                    <BrowserRouter>
                        <AppContent />
                    </BrowserRouter>
                </AlertProvider>
            </AuthProvider>
        </LanguageProvider>
    );
};

export default App;